<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{name}}</h4>
                        </div>
                        <button class="all-btn add-btn pull-right" @click="addAnalog">Қўшиш</button>
                        <!--<div class="pull-right mr-5 mt-2" v-if="comparison.exchangeRate && comparison.exchangeRate > 0">-->
                            <!--1 USD = {{comparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}} UZS ({{comparison.exchangeRateDate}})-->
                        <!--</div>-->
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 table-responsive">
                              <div class="table-wrapper">
                                <table class="table table-striped comparison-table" :style="`min-width: ${900 + financeResult.periods.length * 130}px`">
                                    <tr>
                                        <th class="w-25 text-center">Курсаткичлар номи <br/> Наименование показателя</th>
                                        <th class="w-10 text-center">Сатр коди <br/> Код стр.</th>
                                        <th class="text-center" v-for="(analog, index) in financeResult.periods" :key="index" style="position: relative" >
                                            <table class="w-100">
                                                <tr>
                                                    <th colspan="2" class="border-0">
                                                        Период {{index+1}}
                                                        <div class="row">
                                                            <div class="col-sm-6">
                                                                <custom-date-picker
                                                                        class="form-control"
                                                                        format="dd/MM/yyyy"
                                                                        v-model="analog.startDate"
                                                                        :date="analog.startDate"
                                                                        :clear-button="true">
                                                                </custom-date-picker>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <custom-date-picker
                                                                        class="form-control"
                                                                        format="dd/MM/yyyy"
                                                                        v-model="analog.endDate"
                                                                        :date="analog.endDate"
                                                                        :clear-button="true">
                                                                </custom-date-picker>
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th class="" style="border-left: 0px; border-top: 0px; border-bottom: 0px">даромадлар (фойда) доходы (прибыль)</th>
                                                    <th class="border-0">харажатлар (зарарлар) расходы (убытки)</th>
                                                </tr>
                                            </table>
                                        </th>
                                    </tr>
                                    <tr class="bold-row">
                                        <td class="w-25 text-center">1</td>
                                        <td class="w-10 text-center">2</td>
                                        <td class="text-center" v-for="(analog, index2) in index" :key="index2" style="position: relative">
                                            {{index2+3}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Маҳсулот (товар, иш ва хизмат) ларни сотишдан соф тушум
                                            <br/>Чистая выручка от реализации продукции (товаров, работ и услуг)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['010'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['010'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Сотилган маҳсулот (товар, иш ва хизмат) ларнинг таннархи
                                            <br/>Себестоимость реализованной продукции (товаров, работ и услуг)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['020'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['020'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Маҳсулот (товар, иш ва хизмат) ларни сотишнинг ялпи фойдаси (зарари) (сатр.010-020)<br/>
                                            Валовая прибыль (убыток) от реализации продукции (товаров, работ и услуг)  (стр.010-020)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['030'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['030'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Давр харажатлари, жами  (сатр.050+060+070), шу жумладан:<br/>
                                            Расходы периода, всего  (стр.050+060+070), в том числе:
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['040'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['040'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Сотиш харажатлари <br/>
                                            Расходы по реализации
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['050'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['050'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Маъмурий харажатлар <br/>
                                            Административные расходы
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['060'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['060'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа операцион харажатлар<br/>
                                            Прочие операционные расходы
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['070'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['070'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Келгусида соликка тортиладиган базадан чикариладиган хисобот даври харажатлари<br/>
                                            Расходы отчетного приода искл. из НБ в будушщем
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['080'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['080'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Асосий фаолиятнинг бошқа даромадлари<br/>
                                            Прочие доходы от основной деятельности
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['090'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['090'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Асосий фаолиятнинг фойдаси (зарари) (сатр. 030-040+090) <br/>
                                            Прибыль (убыток) от основной деятельности  (стр.030-040+090)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['100'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['100'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Молиявий фаолиятнинг даромадлари, жами (сатр.120+130+140+150+160), шу жумладан:<br/>
                                            Доходы от финансовой деятельности, всего (стр.120+130+140+150+160), в том числе:
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['110'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['110'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Дивидендлар шаклидаги даромадлар<br/>
                                            Доходы в виде дивидендов
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['120'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['120'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Фоизлар шаклидаги даромадлар<br/>
                                            Доходы в виде процентов
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['130'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['130'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли ижара (лизинг) дан даромадлар<br/>
                                            Доходы от долгосрочной аренды (лизинг)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['140'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['140'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Валюта курси фарқидан даромадлар<br/>
                                            Доходы от валютных курсовых разниц
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['150'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['150'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Молиявий фаолиятнинг бошқа даромадлари<br/>
                                            Прочие доходы от финансовой деятельности
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['160'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['160'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Молиявий фаолият бўйича харажатлар (сатр.180+190+200+210),  шу жумладан:<br/>
                                            Расходы по финансовой деятельности (стр.180+190+200+210),  в том числе:
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['170'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['170'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Фоизлар шаклидаги харажатлар<br/>
                                            Расходы в виде процентов
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['180'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['180'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли ижара (лизинг) бўйича фоизлар шаклидаги харажатлар<br/>
                                            Расходы в виде процентов по долгосрочной аренде (лизингу)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['190'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['190'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Валюта курси фарқидан зарарлар<br/>
                                            Убытки от валютных курсовых разниц
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['200'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['200'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr class="bold-row">
                                        <td class="w-25 text-center">1</td>
                                        <td class="w-10 text-center">2</td>
                                        <td class="text-center" v-for="(analog, index2) in index" :key="index2" style="position: relative">
                                            {{index2+3}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Молиявий фаолият бўйича бошқа харажатлар<br/>
                                            Прочие расходы по финансовой деятельности
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['210'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['210'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Умумхўжалик фаолиятининг фойдаси (зарари) (сатр.100+110-170)<br/>
                                            Прибыль (убыток) от общехозяйственной деятельности (стр.100+110-170)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['220'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['220'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Фавқулоддаги фойда ва зарарлар<br/>
                                            Чрезвычайные прибыли и убытки
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['230'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['230'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Даромад (фойда) солиғини тўлагунга қадар фойда (зарар) (сатр.220+/-230)<br/>
                                            Прибыль (убыток) до уплаты налога на доходы (прибыль) (стр.220+/-230)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['240'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['240'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Даромад (фойда) солиғи<br/>
                                            Налог на доходы (прибыль)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['250'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['250'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Фойдадан бошқа солиқлар ва йиғимлар<br/>
                                            Прочие налоги и сборы от прибыли
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['260'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['260'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">ҳисобот даврининг соф фойдаси (зарари) (сатр.240-250-260)<br/>
                                            Чистая прибыль (убыток) отчетного периода (стр.240-250-260)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['270'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['270'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr class="bold-row">
                                        <td class="w-25 text-center" :colspan="index+2">БЮДЖЕТГА ТЎЛОВЛАР ТЎҒРИСИДА МАЪЛУМОТ<br/>
                                            СПРАВКА О ПЛАТЕЖАХ В БЮДЖЕТ
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Юридик шахслардан олинадиган даромад (фойда) солиғи<br/>
                                            Налог на доходы (прибыль) юридических лиц
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['280'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['280'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Жисмоний шахслардан олинадиган даромад солиғи
                                            Налог на доходы физических лиц
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['290'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['290'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">шу жумладан: шахсий жамғариб бориладиган пенсия ҳисобварақларига ажратмалар
                                            в том числе: отчисления в индивидуальные накопительные пенсионные счета граждан
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['291'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['291'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бензин, дизель ёқилғиси ва газ ишлатганлик учун олинадиган солиқ<br/>
                                            Налог на потребление бензина, дизельного топлива и газа
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['300'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['300'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қўшилган қиймат солиғи<br/>
                                            Налог на добавленную стоимость
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['310'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['310'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Акциз солиғи<br/>
                                            Акцизный налог
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['320'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['320'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ер ости бойликларидан фойдаланганлик учун солиқ<br/>
                                            Налог за пользование недрами
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['330'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['330'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Сув ресурсларидан фойдаланганлик учун солиқ<br/>
                                            Налог за пользование водными ресурсами
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['340'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['340'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Юридик шахсларнинг мол-мулкига солинадиган солиқ<br/>
                                            Налог на имущество юридических лиц
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['350'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['350'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Юридик шахслардан олинадиган ер солиғи<br/>
                                            Земельный налог с юридических лиц
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['360'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['360'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr class="bold-row">
                                        <td class="w-25 text-center">1</td>
                                        <td class="w-10 text-center">2</td>
                                        <td class="text-center" v-for="(analog, index2) in index" :key="index2" style="position: relative">
                                            {{index2+3}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ягона солиқ тўлови<br/>
                                            Единый налоговый платеж
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['370'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['370'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ягона ер солиғи<br/>
                                            Единый земельный налог
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['380'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['380'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қатъий белгиланган солиқ<br/>
                                            Фиксированный налог
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['390'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['390'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа солиқлар<br/>
                                            Прочие налоги
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['400'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['400'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Давлат мақсадли жамғармаларига мажбурий ажратмалар<br/>
                                            Обязательные отчисления в государственные целевые фонды
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['410'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['410'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бюджетдан ташқари Пенсия жамгармасига мажбурий туловлар <br/>
                                            Обязательные отчисления во внебюджетный Пенсионный фонд
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['420'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['420'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Мактаб таълими жамгармасига мажбурий туловлар <br/>
                                            Обязательные отчисления в Фонд школ.образования
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['430'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['430'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ягона ижтимоий тўлов ва фуқароларнинг бюджетдан ташқари Пенсия жамғармасига суғурта бадаллари<br/>
                                            Единый социальный платеж и страховые взносы граждан во внебюджетный Пенсионный фонд
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['440'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['440'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Импорт бўйича божхона божи<br/>
                                            Импортные таможенные пошлины
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['450'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['450'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Маҳаллий бюджетга йиғимлар<br/>
                                            Сборы в местный бюджет
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['460'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['460'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бюджетга тўловларнинг кечиктирилганлиги учун молиявий жазолар<br/>
                                            Финансовые санкции за просроченные платежи в бюджет
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['470'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['470'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Жами бюджетга тўловлар суммаси (280 дан 470 сатргача 291 сатрдан ташқари)<br/>
                                            Всего сумма платежей в бюджет (стр. с 280 по 470 кроме стр. 291)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['480'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['480'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.expense" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>

                                    <!--<tr>-->
                                        <!--<th class="text-center" v-for="(analog, index) in comparison.analogs" :key="index" style="position: relative">-->
                                            <!--аналог {{index + 1}}-->
                                            <!--<i class="fa fa-remove red"-->
                                               <!--style="position: absolute;right: 3px;top: 3px;cursor: pointer"-->
                                               <!--@click="removeAnalog(index)"></i>-->
                                            <!--<v-select-->
                                                    <!--:options="uyJoyAnalogs"-->
                                                    <!--label="name"-->
                                                    <!--:filterable="false"-->
                                                    <!--v-model="analog.apiAnalog"-->
                                                    <!--@change="onApiAnalogChange"-->
                                                    <!--:clearable="false"-->
                                            <!--&gt;-->
                                                <!--<template slot="option" slot-scope="option" v-if="option && option.name">-->
                                                    <!--<div v-html="option.name" style="font-weight: bold"></div>-->
                                                    <!--<template v-if="option.variations">-->
                                                        <!--<template v-for="field in option.variations">-->
                                                            <!--<template v-if="field.code === 'area_all'">-->
                                                                <!--<div class="text-dark" :key="field.id">-->
                                                                    <!--<span>{{field.label}} : {{field.value}}</span>-->
                                                                <!--</div>-->
                                                            <!--</template>-->
                                                        <!--</template>-->
                                                        <!--<template>-->
                                                            <!--<div class="text-dark">-->
                                                                <!--<span>{{option.price | currency('', 2, { thousandsSeparator: ' ' })}} {{option.priceUnit.symbol}}</span>-->
                                                            <!--</div>-->
                                                        <!--</template>-->
                                                    <!--</template>-->
                                                <!--</template>-->
                                                <!--<span slot="no-options">{{$t("messages.combo.empty")}}</span>-->
                                            <!--</v-select>-->
                                        <!--</th>-->
                                    <!--</tr>-->
                                </table>
                              </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomDatePicker from '@/views/common/CustomDatePicker';
   // import Treeselect from '@riophae/vue-treeselect';
   //  import {formatDate/*, parseDate*/} from '@/shared/utils';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    // import {required, requiredUnless, minValue, minLength, maxLength} from 'vuelidate/lib/validators';

    export default {
        name: "BusinessFinanceResultView",
        components: {
            CustomDatePicker
           // Treeselect
        },
        data() {
            return {
                processing: false,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                businessId: ((this.$route.params.hasOwnProperty('id') && this.$route.params.id) ? this.$route.params.id : null),
                name: '',
                region: null,
                index: 0,
                financeResult: {
                    '010': {
                        code: '010',
                        years: []
                    },
                    '020': {
                        code: '020',
                        years: []
                    },
                    '030': {
                        code: '030',
                        years: []
                    },
                    '040': {
                        code: '040',
                        years: []
                    },
                    '050': {
                        code: '050',
                        years: []
                    },
                    '060': {
                        code: '060',
                        years: []
                    },
                    '070': {
                        code: '070',
                        years: []
                    },
                    '080': {
                        code: '080',
                        years: []
                    },
                    '090': {
                        code: '090',
                        years: []
                    },
                    '100': {
                        code: '100',
                        years: []
                    },
                    '110': {
                        code: '110',
                        years: []
                    },
                    '120': {
                        code: '120',
                        years: []
                    },
                    '130': {
                        code: '130',
                        years: []
                    },
                    '140': {
                        code: '140',
                        years: []
                    },
                    '150': {
                        code: '150',
                        years: []
                    },
                    '160': {
                        code: '160',
                        years: []
                    },
                    '170': {
                        code: '170',
                        years: []
                    },
                    '180': {
                        code: '180',
                        years: []
                    },
                    '190': {
                        code: '190',
                        years: []
                    },
                    '200': {
                        code: '200',
                        years: []
                    },
                    '210': {
                        code: '210',
                        years: []
                    },
                    '220': {
                        code: '220',
                        years: []
                    },
                    '230': {
                        code: '230',
                        years: []
                    },
                    '240': {
                        code: '240',
                        years: []
                    },
                    '250': {
                        code: '250',
                        years: []
                    },
                    '260': {
                        code: '260',
                        years: []
                    },
                    '270': {
                        code: '270',
                        years: []
                    },
                    '280': {
                        code: '280',
                        years: []
                    },
                    '290': {
                        code: '290',
                        years: []
                    },
                    '291': {
                        code: '291',
                        years: []
                    },
                    '300': {
                        code: '300',
                        years: []
                    },
                    '310': {
                        code: '310',
                        years: []
                    },
                    '320': {
                        code: '320',
                        years: []
                    },
                    '330': {
                        code: '330',
                        years: []
                    },
                    '340': {
                        code: '340',
                        years: []
                    },
                    '350': {
                        code: '350',
                        years: []
                    },
                    '360': {
                        code: '360',
                        years: []
                    },
                    '370': {
                        code: '370',
                        years: []
                    },
                    '380': {
                        code: '380',
                        years: []
                    },
                    '390': {
                        code: '390',
                        years: []
                    },
                    '400': {
                        code: '400',
                        years: []
                    },
                    '410': {
                        code: '410',
                        years: []
                    },
                    '420': {
                        code: '420',
                        years: []
                    },
                    '430': {
                        code: '430',
                        years: []
                    },
                    '440': {
                        code: '440',
                        years: []
                    },
                    '450': {
                        code: '450',
                        years: []
                    },
                    '460': {
                        code: '460',
                        years: []
                    },
                    '470': {
                        code: '470',
                        years: []
                    },
                    '480': {
                        code: '480',
                        years: []
                    },
                    businessId: this.businessId,
                    periods: [],
                    data: {

                    }
                },
                ref: {
                    ...COMPARISON_REFERENCES,
                    provinces: []
                },
                createDate: null,
                sectionResId: null,
                sectionType: null,
                maxMadeYear: new Date().getFullYear()
            }
        },
        validations() {
            return {
            }
        },
        computed: {
            // calculated() {
            //
            // },
        },
        methods: {
            init() {
                const vm = this;
                this.$http.get('asset/finance-result/' + this.businessId)
                    .then(res => {
                        if (res.data) {
                            for (const key in res.data.data) {
                                vm.financeResult[key].years = res.data.data[key];
                            }
                            vm.financeResult.periods = res.data.periods;
                            if (vm.financeResult.periods) {
                                vm.index = vm.financeResult.periods.length;
                            }
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            cancel() {
                this.$router.push(this.parentName + 'business/edit/' + this.businessId);
            },
            save() {
                // this.$v.$touch();
                // if (this.$v.$invalid) {
                //     return;
                // }
                this.financeResult.businessId = this.businessId;
                var years_columns = [];
                this.financeResult.periods.forEach((field) => {
                    years_columns.push({
                        startDate: field.startDate,
                        endDate: field.endDate,
                    });
                });
                this.financeResult.periods = years_columns;
                for (let key in this.financeResult) {
                    if (!(key === "businessId" || key === "periods" || key === "data")) {
                        this.financeResult.data[key] = this.financeResult[key].years;
                    }
                }
                console.log(this.financeResult);
                this.processing = true;
                this.$http.post('asset/save-finance-result', this.financeResult)
                    .then(res => {
                        console.log(res.data);
                        if (res && res.status ===200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('business.financeResult.success'),
                                type: 'success'
                            });
                            this.$router.push(this.parentName + 'business/edit/' + this.businessId);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            addAnalog() {
                if (this.index > 2) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: 'Охирги 3 йил киритилади',
                        type: 'warning'
                    });
                    return;
                }
                this.index += 1;
                for (const key in this.financeResult) {
                    if (!(key === "businessId" || key === "periods" || key === "data") ) {
                        this.financeResult[key].years.push({
                            profit: 0,
                            expense: 0,
                        });
                    }
                }
                if (!this.financeResult.periods){
                    this.financeResult.periods = [];
                }
                this.financeResult.periods.push({
                    startDate: null,
                    endDate: null,
                });
            },
            removeAnalog(index) {
                this.comparison.analogs.splice(index, 1);
            },
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>
